import React from 'react'
import classNames from 'classnames'
import { InternalLink } from '@/atoms/InternalLink'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { WATCH_CATEGORY_TABS } from './constants'

interface CategoryTabsProps {
  activeSlug?: string
}

export const CategoryTabs: React.FC<CategoryTabsProps> = ({ activeSlug }) => {
  const { t } = useTranslate('watch')
  const track = useSafeTrack()

  const getTabLabel = (key: string, defaultLabel: string): string => {
    switch (key) {
      case 'all':
        return t('all', 'All')
      case 'movies':
        return t('movies', 'Movies')
      case 'series':
        return t('series', 'Series')
      case 'comedy':
        return t('comedy', 'Comedy')
      case 'free':
        return t('free', 'Free')
      case 'family':
        return t('family', 'Family')
      default:
        return defaultLabel
    }
  }

  const handleClick = (tabKey: string) => {
    track('Category Tab Clicked', { tab: tabKey })
  }

  return (
    <nav
      aria-label={t('categoryNavigation', 'Category Navigation')}
      className="relative -mx-4 flex gap-2 overflow-x-auto px-4 pt-8 scrollbar-none sm:-mx-8 sm:px-8 md:-mx-12 md:px-12 lg:pt-4 xl:-mx-16 xl:px-16"
    >
      {WATCH_CATEGORY_TABS.map((tab) => {
        const isActive = activeSlug ? tab.matchSlugs.includes(activeSlug) : tab.key === 'all'

        return (
          <InternalLink
            key={tab.key}
            href={tab.href}
            prefetch
            onClick={() => handleClick(tab.key)}
            className={classNames(
              'flex h-8 shrink-0 items-center justify-center whitespace-nowrap rounded-full px-4 text-[13px] font-semibold transition-colors',
              'lg:h-12 lg:px-[18px] lg:text-[17px]',
              isActive ? 'bg-white text-black' : 'bg-white/25 text-white backdrop-blur-[32px] hover:bg-white/30',
            )}
          >
            {getTabLabel(tab.key, tab.defaultLabel)}
          </InternalLink>
        )
      })}
    </nav>
  )
}
